import './src/styles/global.css';

require('prismjs/themes/prism-okaidia.css');

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", { page_path: location.pathname });
  }
};